





















import { Component, Prop, Vue } from 'vue-property-decorator';
import TaskCard from '@/components/TaskCard.vue';

@Component({
  name: 'Archive',
  components: { TaskCard },
})

export default class Archive extends Vue {
  @Prop({ type: Array, required: true }) public archivedCards!: [];
}
